<template>
  <div class="player-menu">
    <v-menu v-model="show" bottom left :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn :small="small" dark color="light-blue" fab v-on="on" v-bind="attrs">
          <v-icon dark >mdi-menu</v-icon>
        </v-btn>
      </template>

      <v-list v-if="!isTournament()">
        <v-list-item v-if="!isSitting()">
          <v-list-item-icon>
            <v-icon>mdi-cards-playing-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-text-field v-model="chips" @keydown.enter="sitChips" label="Sit (chips)">
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="standupOnly" v-if="isSitting()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Stand Up
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="leaveImmediately" v-if="!isSitting()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Leave Table
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="sitout" v-if="isSitting() && !isSittingOut()">
          <v-list-item-icon>
            <v-icon>mdi-coffee</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Sit Out
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="sitback" v-if="isSittingOut()">
          <v-list-item-icon>
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Sit Back
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isSitting()">
          <v-list-item-icon>
            <v-icon>mdi-reload</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-text-field v-model="chips" @keydown.enter="reload" label="reload">
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Result: ${{ this.getResult() }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="leaveImmediately" v-if="isSitting()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Leave Table While Sitting (!)
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="restart">
          <v-list-item-icon>
            <v-icon>mdi-restart</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Restart
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isDebug" link @click="_TEST_DC">
          <v-list-item-icon>
            <v-icon>mdi-restart</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            <span style="border: solid darkred">TEST D/C</span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-power</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Shutdown
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item link @click="tourneyRebuy" v-if="isRegistered() && !isSitting() && tourneyStarted() && !tourneyEnded()">
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Re-buy
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="tourneyAddon" v-if="isRegistered() && isSitting() && tourneyStarted() && !tourneyEnded()">
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Add-on
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="register" v-if="!isRegistered()">
          <v-list-item-icon>
            <v-icon>mdi-cards-playing-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Register
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="unregister" v-if="isRegistered() && !tourneyStarted()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Unregister
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-text-field v-model="rebuysTotalInput" @keydown.enter="updateRebuysTotal" label="Update Total Rebuys">
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="sitout" v-if="tourneyStarted() && !tourneyEnded() && isSitting() && !isSittingOut()">
          <v-list-item-icon>
            <v-icon>mdi-coffee</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Sit Out
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="sitback" v-if="tourneyStarted() && isSittingOut() && !tourneyEnded()">
          <v-list-item-icon>
            <v-icon>mdi-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Sit Back
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="leaveImmediately" v-if="!isSitting() || tourneyEnded()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Leave Room
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="leaveImmediately" v-if="isSitting() && !tourneyEnded()">
          <v-list-item-icon>
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            Leave While <template v-if="tourneyStarted()">Playing</template><template v-else>Registered</template> (!)
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="restart">
          <v-list-item-icon>
            <v-icon>mdi-restart</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Restart
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isDebug" link @click="_TEST_DC">
          <v-list-item-icon>
            <v-icon>mdi-restart</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            TEST D/C
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-power</v-icon>
          </v-list-item-icon>
          <v-list-item-content >
            Shutdown
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-menu>
  </div>
</template>

<script>
import bus from '../../bus';
import { mapGetters } from 'vuex';
export default {
  props: {
    name: String,
    slot: String,
    small: Boolean
  },
  computed: {
    state() {
      return this.accountState(this.name, this.slot);
    },
    chatAcc() {
      return this.chatAccounts[this.name];
    },
    tourney_state() {
      let acc = this.chatAcc;
      if (!acc) {
        return null;
      }

      // get tourney rebuys info
      for (let el of (acc.tourney_states || [])) {
        if (el.gameCode === this.getCode()) {
          return el;
        }
      }
      return null;
    },
    rebuysTotal() {
      return (this.tourney_state || {}).rebuys_total || 0;
    },
    rebuysTotalInput: {
      get() {
        // before explicit input is set, use the current value
        if (this.a_rebuysTotalInput === null) {
          return this.rebuysTotal;
        }
        // otherwise use explicit value
        return this.a_rebuysTotalInput;
      },
      set(newValue) {
        // set the value
        this.a_rebuysTotalInput = newValue;
      },
    },
    ...mapGetters([
      "accountState",
      "chatAccounts",
      "isDebug",
    ]),
  },
  data() {
    return {
      chips: 0,
      show: false,
      shareHandSN: 0,
      a_rebuysTotalInput: null,
    };
  },
  methods: {
    getCode() {
      if (!this.state || !this.state.room) {
        return '';
      }
      if (this.state.room.mainRoomDataObject) {
        return this.state.room.mainRoomDataObject.gameCode;
      }
      return this.state.room.gameCode;
    },

    getPlayer() {
      if (!this.state) return null;
      let pid = this.state.player_id;
      var k;
      if ("p1" in this.state) {
        for (k of ["p1", "p2", "p3"]) {
          let p = this.state[k];
          if (p && p.id === pid) {
            return p
          }
        }
      } else {
        for (k in this.state.players) {
          let p = this.state.players[k];
          if (p && p.id === pid) {
            return p
          }
        }
      }
      return null;
    },

    // tourney stuff
    isTournament() {
      if (!this.state || !this.state.settings) {
        return false;
      }

      return 'prizePlan' in this.state.settings && !(this.state.settings.rummy);
    },
    isRegistered() {
      if (this.isSitting()) {
        return true;
      }

      if (!this.state) { return false; }
      if (!this.state.room) { return false; }

      let pid = this.state.player_id;

      // see if we are in any players or ranking list anywhere
      var lists = [this.state.room.players, this.state.room.ranking];
      if (this.state.room.mainRoomDataObject) {
        lists.push(this.state.room.mainRoomDataObject.players);
        lists.push(this.state.room.mainRoomDataObject.ranking);
      }
      for (let list of lists) {
        if (!list) { continue; }
        for (let ent of list) {
          if (ent.playerId === pid) {
            return true;
          }
        }
      }
    },
    tourneyStarted() {
      if (!this.state || !this.state.room) {
        return false;
      }

      return this.state.room.status !== 'PREPARE';
    },
    tourneyEnded() {
      if (!this.state || !this.state.room) {
        return false;
      }

      if (this.state.room.mainRoomDataObject) {
        return this.state.room.mainRoomDataObject.status === 'END';
      }

      return this.state.room.status === 'END';
    },
    register() {
      this.show = false;
      bus.$emit("register", {name: this.name, slot: this.slot});
    },
    unregister() {
      this.show = false;
      bus.$emit("unregister", {name: this.name, slot: this.slot});
    },
    tourneyRebuy() {
      this.show = false;
      bus.$emit("tourney-rebuy", {name: this.name, slot: this.slot});
    },
    tourneyAddon() {
      this.show = false;
      bus.$emit("tourney-addon", {name: this.name, slot: this.slot});
    },
    isSittingOut() {
      let p = this.getPlayer();
      if (p && p.sitout) return true;
      return false;
    },
    isSitting() {
      let p = this.getPlayer();

      if (!p) return false;

      if (p.seat === 0) return true;

      if (p.seat && p.seat >= 0) return true;

      return false;
    },
    getResult() {
      let p = this.getPlayer();
      let d = this.getDivider();
      if (!p) return 0;
      if (p && p.result) return (p.result / d).toFixed(2);
      if (this.state && this.state.room && this.state.room.ranking) {
        for (let r of this.state.room.ranking) {
          if (r.playerId === p.id) {
            return (r.diff / d).toFixed(2)
          }
        }
      }
      return 0;
    },
    getDivider() {
      if (!this.state || !this.state.settings) {
        return 1;
      }
      if (this.state.settings.withDecimal) {
        return 100;
      }
      return 1
    },
    standupOnly() {
      this.show = false;
      bus.$emit("stand-up-only", {name: this.name, slot: this.slot});
    },
    leaveImmediately() {
      this.show = false;
      bus.$emit("leave-immediately", {name: this.name, slot: this.slot});
    },
    sitout() {
      this.show = false;
      bus.$emit("sitout", {name: this.name, slot: this.slot});
    },
    shareHand() {
      this.show = false;
      bus.$emit("share-hand", {name: this.name, slot: this.slot, handSN: this.shareHandSN, message: ''});
    },
    sitChips() {
      // only stop showing if it succeeded
      let settings = this.state.settings;
      if (!this.chips) {
        return;
      }
      let chips = Math.round(parseFloat(this.chips)*100)/100;
      if (!settings) {
        return;
      }
      if (settings.withDecimal) {
        chips *= 100;
      }
      // after withDecimal, we should always have an int amount
      chips = Math.round(chips);

      this.show = false;
      bus.$emit("sit-chips", {name: this.name, slot: this.slot, chips: chips});
    },
    sitback() {
      this.show = false;
      bus.$emit("sitback", {name: this.name, slot: this.slot});
    },
    restart() {
      this.show = false;
      bus.$emit("restart", this.name);
    },
    _TEST_DC() {
      this.show = false;
      bus.$emit("_TEST_DC", this.name);
    },
    logout() {
      this.show = false;
      bus.$emit("logout", this.name);
    },
    reload() {
      this.show = false;
      let settings = this.state.settings;
      if (!this.chips) return;
      let chips = parseFloat(this.chips);
      if (settings && settings.withDecimal) {
        chips *= 100;
        chips = Math.round(chips);
      } else {
        chips = Math.round(chips*100)/100;
      }

      bus.$emit("reload-chips", {name: this.name, slot: this.slot, chips: chips, withDecimal: settings.withDecimal});
    },
    updateRebuysTotal() {
      let to_emit = {
        name: this.name,
        slot: this.slot,
        gameCode: this.getCode(),
        rebuysTotal: this.rebuysTotalInput
      };
      console.log("emitting on bus update-rebuys-total", to_emit);
      bus.$emit("update-rebuys-total", to_emit);
      this.show = false;
    },
  }
}
</script>

<style scoped>
.player-menu {
  display: flex;
  position: absolute;
  top: 0px;
  left: 350px;
}
</style>
